export default __webpack_public_path__ + "ce19ba6626e726fff487f14bbd36bee9.jpg";